// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadAttach_root__1jOzz"};